import React, { FC } from 'react';

import clsx from 'clsx';
import { Message } from 'react-hook-form';
import PhoneInput from 'react-phone-number-input/input';

import InputError from 'components/Inputs/InputError';
import useTrimmedPhoneNumber from 'hooks/useTrimmedPhoneNumber';

import styles from './PhoneNumberInput.module.scss';

interface PhoneNumberInputProps {
  value: string;
  label: string;
  errorMessage?: Message | undefined;
  className?: string;
  onChange?: any;
  placeholder?: string;
  name?: string;
  onBlur?: any;
  disabled?: boolean;
  inputContainerClassname?: string;
}

const PhoneNumberInput: FC<PhoneNumberInputProps> = ({
  onChange,
  value = '',
  label,
  errorMessage,
  className,
  placeholder,
  name,
  onBlur,
  disabled,
}) => {
  const [trimmedValue, handleChange] = useTrimmedPhoneNumber(value, onChange);

  return (
    <div className={className}>
      <div className={styles.inputContainer}>
        {label && <p className={styles.label}>{label}</p>}
        <PhoneInput
          defaultCountry="US"
          onChange={handleChange}
          value={trimmedValue}
          className={clsx(styles.input, !!errorMessage && styles.error)}
          onBlur={onBlur}
          placeholder={placeholder}
          name={name}
          disabled={disabled}
        />
      </div>
      {!!errorMessage && <InputError errorMessage={errorMessage} />}
    </div>
  );
};

export default PhoneNumberInput;
